frappe.provide("frappe.ui");

frappe.ui.ListDashboard = class ListDashboard {
	constructor({ list_view, settings }) {
		this.list_view = list_view;
		this.settings = settings;
		const page_toolbars = list_view.parent.getElementsByClassName("page-toolbar");
		if (!page_toolbars.length) {
			return;
		}
		this.page_toolbar = page_toolbars[0];
		this.data = {};
		this.active_card_id = null;
		this.request_id = 0;
	}

	refresh() {
		if (frappe.is_mobile()) return; // @dokos: hide list dashboard on mobile
		this.build();
	}

	async build() {
		const request_id = ++this.request_id;
		await this.get_data();

		if (request_id !== this.request_id) {
			return;
		}

		this.page_toolbar.innerHTML = "";

		const dashboard_container = document.createElement("div");
		dashboard_container.classList.add("list-dashboard", "pb-4", "w-100");
		this.page_toolbar.appendChild(dashboard_container);

		this.settings.cards.forEach((card_settings) => {
			const card_id = card_settings.id || card_settings.value;
			const status_data = this.data[card_id] || {
				count: 0,
				total: 0,
			};
			const card = document.createElement("div");
			card.classList.add("dashboard-card");

			if (this.active_card_id === card_id) {
				card.classList.add("active");
			}

			const color = card_settings.color_map?.[card_settings.value] || card_settings.color;
			const bg = card_settings.bg_map?.[card_settings.value] || card_settings.bg;

			if (color) card.style.setProperty("--card-color", color);
			if (bg) card.style.setProperty("--card-bg-color", bg);

			card.onclick = () => {
				if (this.active_card_id === card_id) {
					// Toggle off: clear filters
					this.active_card_id = null;
					this._clear_card_filters();
				} else {
					// Switch to this card
					this.active_card_id = card_id;
					this._clear_card_filters().then(() => {
						if (card_settings.filters) {
							this.list_view.filter_area.add(card_settings.filters);
						} else {
							this.list_view.filter_area.add(
								this.list_view.doctype,
								card_settings.field,
								"=",
								card_settings.value
							);
						}
					});
				}
			};

			// Icon container
			const icon_wrapper = document.createElement("div");
			icon_wrapper.classList.add("icon-wrapper");
			icon_wrapper.innerHTML = frappe.utils.icon(card_settings.icon, "lg");

			// Text container
			const text_content = document.createElement("div");
			text_content.classList.add("text-content");

			const label = document.createElement("div");
			label.classList.add("label");

			const label_text = document.createElement("span");
			label_text.innerText = card_settings.label;
			label.appendChild(label_text);

			const count_badge = document.createElement("span");
			count_badge.classList.add("count-badge");
			count_badge.innerText = status_data.count || 0;
			label.appendChild(count_badge);

			const value = document.createElement("div");
			value.classList.add("value");
			if (status_data.total !== undefined) {
				value.innerText = frappe.format(
					status_data.total || 0,
					{
						fieldtype: "Currency",
						currency: card_settings.currency || frappe.boot.sysdefaults.currency,
					},
					{
						only_value: true,
					}
				);
			} else {
				value.innerText = status_data.count || 0;
			}

			if (card_settings.description) {
				const info_icon = document.createElement("span");
				info_icon.classList.add("card-info");
				info_icon.title = card_settings.description;
				info_icon.innerHTML = frappe.utils.icon("info", "xs");
				value.appendChild(info_icon);
			}

			text_content.appendChild(label);
			text_content.appendChild(value);

			card.appendChild(icon_wrapper);
			card.appendChild(text_content);

			dashboard_container.appendChild(card);
		});

		this.page_toolbar.classList.remove("hide");
	}

	_get_all_card_fieldnames() {
		const fields = new Set();
		for (const card of this.settings.cards) {
			if (card.field) fields.add(card.field);
			for (const f of card.filters || []) {
				if (Array.isArray(f)) {
					if (f.length === 3) fields.add(f[0]);
					else if (f.length === 4) fields.add(f[1]);
				}
			}
		}
		return fields;
	}

	_clear_card_filters() {
		const fieldnames = this._get_all_card_fieldnames();
		const promises = [];
		for (const fieldname of fieldnames) {
			promises.push(this.list_view.filter_area.remove(fieldname));
		}
		return Promise.all(promises);
	}

	async get_data() {
		if (this.settings.get_data) {
			this.data = await this.settings.get_data(this.list_view);
			return;
		}

		const filters = this.list_view.get_filters_for_args();

		return frappe.call({
			method: this.settings.method,
			args: {
				...this.settings.args,
				filters,
				cards: this.settings.cards,
			},
			callback: (response) => {
				this.data = response.message || {};
			},
		});
	}
};
